var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RotateOutUpRight = exports.RotateOutUpLeft = exports.RotateOutDownRight = exports.RotateOutDownLeft = exports.RotateInUpRight = exports.RotateInUpLeft = exports.RotateInDownRight = exports.RotateInDownLeft = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _animationBuilder = require("../animationBuilder");
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOf2.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return (0, _possibleConstructorReturn2.default)(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var _worklet_5936735946747_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,animation(1,config)),transform:[{rotate:delayFunction(delay,animation('0deg',config))},{translateX:delayFunction(delay,animation(0,config))},{translateY:delayFunction(delay,animation(0,config))}]},initialValues:{opacity:0,transform:[{rotate:'-90deg'},{translateX:values.targetWidth/2-values.targetHeight/2},{translateY:-(values.targetWidth/2-values.targetHeight/2)}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Rotate.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","opacity","transform","rotate","translateX","translateY","targetWidth","targetHeight"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Rotate.ts"],"mappings":"AA2BY,SAAAA,SAAMA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEjB,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAC,CACnDM,SAAS,CAAE,CACT,CAAEC,MAAM,CAAEV,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,MAAM,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC3D,CAAEQ,UAAU,CAAEX,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC1D,CAAES,UAAU,CAAEZ,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAE,CAAC,CAE9D,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACVC,SAAS,CAAE,CACT,CAAEC,MAAM,CAAE,QAAS,CAAC,CACpB,CAAEC,UAAU,CAAEZ,MAAM,CAACc,WAAW,CAAG,CAAC,CAAGd,MAAM,CAACe,YAAY,CAAG,CAAE,CAAC,CAChE,CAAEF,UAAU,CAAE,EAAEb,MAAM,CAACc,WAAW,CAAG,CAAC,CAAGd,MAAM,CAACe,YAAY,CAAG,CAAC,CAAE,CAAC,CACpE,CACD,GAAGV,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var RotateInDownLeft = exports.RotateInDownLeft = function(_ComplexAnimationBuil) {
    (0, _inherits2.default)(RotateInDownLeft, _ComplexAnimationBuil);
    var _super = _createSuper(RotateInDownLeft);
    function RotateInDownLeft() {
        var _this;
        (0, _classCallCheck2.default)(this, RotateInDownLeft);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.build = function() {
            var delayFunction = _this.getDelayFunction();
            var _this$getAnimationAnd = _this.getAnimationAndConfig(), _this$getAnimationAnd2 = (0, _slicedToArray2.default)(_this$getAnimationAnd, 2), animation = _this$getAnimationAnd2[0], config = _this$getAnimationAnd2[1];
            var delay = _this.getDelay();
            var callback = _this.callbackV;
            var initialValues = _this.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            opacity: delayFunction(delay, animation(1, config)),
                            transform: [
                                {
                                    rotate: delayFunction(delay, animation("0deg", config))
                                },
                                {
                                    translateX: delayFunction(delay, animation(0, config))
                                },
                                {
                                    translateY: delayFunction(delay, animation(0, config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            opacity: 0,
                            transform: [
                                {
                                    rotate: "-90deg"
                                },
                                {
                                    translateX: values.targetWidth / 2 - values.targetHeight / 2
                                },
                                {
                                    translateY: -(values.targetWidth / 2 - values.targetHeight / 2)
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_5936735946747_init_data;
                anonymous.__workletHash = 5936735946747;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this;
    }
    (0, _createClass2.default)(RotateInDownLeft, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new RotateInDownLeft();
            }
        }
    ]);
    return RotateInDownLeft;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_8696446236410_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,animation(1,config)),transform:[{rotate:delayFunction(delay,animation('0deg',config))},{translateX:delayFunction(delay,animation(0,config))},{translateY:delayFunction(delay,animation(0,config))}]},initialValues:{opacity:0,transform:[{rotate:'90deg'},{translateX:-(values.targetWidth/2-values.targetHeight/2)},{translateY:-(values.targetWidth/2-values.targetHeight/2)}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Rotate.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","opacity","transform","rotate","translateX","translateY","targetWidth","targetHeight"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Rotate.ts"],"mappings":"AAsEY,SAAAA,SAAMA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEjB,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAC,CACnDM,SAAS,CAAE,CACT,CAAEC,MAAM,CAAEV,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,MAAM,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC3D,CAAEQ,UAAU,CAAEX,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC1D,CAAES,UAAU,CAAEZ,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAE,CAAC,CAE9D,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACVC,SAAS,CAAE,CACT,CAAEC,MAAM,CAAE,OAAQ,CAAC,CACnB,CAAEC,UAAU,CAAE,EAAEZ,MAAM,CAACc,WAAW,CAAG,CAAC,CAAGd,MAAM,CAACe,YAAY,CAAG,CAAC,CAAE,CAAC,CACnE,CAAEF,UAAU,CAAE,EAAEb,MAAM,CAACc,WAAW,CAAG,CAAC,CAAGd,MAAM,CAACe,YAAY,CAAG,CAAC,CAAE,CAAC,CACpE,CACD,GAAGV,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var RotateInDownRight = exports.RotateInDownRight = function(_ComplexAnimationBuil2) {
    (0, _inherits2.default)(RotateInDownRight, _ComplexAnimationBuil2);
    var _super2 = _createSuper(RotateInDownRight);
    function RotateInDownRight() {
        var _this2;
        (0, _classCallCheck2.default)(this, RotateInDownRight);
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++){
            args[_key2] = arguments[_key2];
        }
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        _this2.build = function() {
            var delayFunction = _this2.getDelayFunction();
            var _this2$getAnimationAn = _this2.getAnimationAndConfig(), _this2$getAnimationAn2 = (0, _slicedToArray2.default)(_this2$getAnimationAn, 2), animation = _this2$getAnimationAn2[0], config = _this2$getAnimationAn2[1];
            var delay = _this2.getDelay();
            var callback = _this2.callbackV;
            var initialValues = _this2.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            opacity: delayFunction(delay, animation(1, config)),
                            transform: [
                                {
                                    rotate: delayFunction(delay, animation("0deg", config))
                                },
                                {
                                    translateX: delayFunction(delay, animation(0, config))
                                },
                                {
                                    translateY: delayFunction(delay, animation(0, config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            opacity: 0,
                            transform: [
                                {
                                    rotate: "90deg"
                                },
                                {
                                    translateX: -(values.targetWidth / 2 - values.targetHeight / 2)
                                },
                                {
                                    translateY: -(values.targetWidth / 2 - values.targetHeight / 2)
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_8696446236410_init_data;
                anonymous.__workletHash = 8696446236410;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this2;
    }
    (0, _createClass2.default)(RotateInDownRight, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new RotateInDownRight();
            }
        }
    ]);
    return RotateInDownRight;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_5565260546330_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,animation(1,config)),transform:[{rotate:delayFunction(delay,animation('0deg',config))},{translateX:delayFunction(delay,animation(0,config))},{translateY:delayFunction(delay,animation(0,config))}]},initialValues:{opacity:0,transform:[{rotate:'90deg'},{translateX:values.targetWidth/2-values.targetHeight/2},{translateY:values.targetWidth/2-values.targetHeight/2}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Rotate.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","opacity","transform","rotate","translateX","translateY","targetWidth","targetHeight"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Rotate.ts"],"mappings":"AAiHY,SAAAA,SAAMA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEjB,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAC,CACnDM,SAAS,CAAE,CACT,CAAEC,MAAM,CAAEV,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,MAAM,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC3D,CAAEQ,UAAU,CAAEX,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC1D,CAAES,UAAU,CAAEZ,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAE,CAAC,CAE9D,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACVC,SAAS,CAAE,CACT,CAAEC,MAAM,CAAE,OAAQ,CAAC,CACnB,CAAEC,UAAU,CAAEZ,MAAM,CAACc,WAAW,CAAG,CAAC,CAAGd,MAAM,CAACe,YAAY,CAAG,CAAE,CAAC,CAChE,CAAEF,UAAU,CAAEb,MAAM,CAACc,WAAW,CAAG,CAAC,CAAGd,MAAM,CAACe,YAAY,CAAG,CAAE,CAAC,CACjE,CACD,GAAGV,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var RotateInUpLeft = exports.RotateInUpLeft = function(_ComplexAnimationBuil3) {
    (0, _inherits2.default)(RotateInUpLeft, _ComplexAnimationBuil3);
    var _super3 = _createSuper(RotateInUpLeft);
    function RotateInUpLeft() {
        var _this3;
        (0, _classCallCheck2.default)(this, RotateInUpLeft);
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++){
            args[_key3] = arguments[_key3];
        }
        _this3 = _super3.call.apply(_super3, [
            this
        ].concat(args));
        _this3.build = function() {
            var delayFunction = _this3.getDelayFunction();
            var _this3$getAnimationAn = _this3.getAnimationAndConfig(), _this3$getAnimationAn2 = (0, _slicedToArray2.default)(_this3$getAnimationAn, 2), animation = _this3$getAnimationAn2[0], config = _this3$getAnimationAn2[1];
            var delay = _this3.getDelay();
            var callback = _this3.callbackV;
            var initialValues = _this3.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            opacity: delayFunction(delay, animation(1, config)),
                            transform: [
                                {
                                    rotate: delayFunction(delay, animation("0deg", config))
                                },
                                {
                                    translateX: delayFunction(delay, animation(0, config))
                                },
                                {
                                    translateY: delayFunction(delay, animation(0, config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            opacity: 0,
                            transform: [
                                {
                                    rotate: "90deg"
                                },
                                {
                                    translateX: values.targetWidth / 2 - values.targetHeight / 2
                                },
                                {
                                    translateY: values.targetWidth / 2 - values.targetHeight / 2
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_5565260546330_init_data;
                anonymous.__workletHash = 5565260546330;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this3;
    }
    (0, _createClass2.default)(RotateInUpLeft, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new RotateInUpLeft();
            }
        }
    ]);
    return RotateInUpLeft;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_2345342195739_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,animation(1,config)),transform:[{rotate:delayFunction(delay,animation('0deg',config))},{translateX:delayFunction(delay,animation(0,config))},{translateY:delayFunction(delay,animation(0,config))}]},initialValues:{opacity:0,transform:[{rotate:'-90deg'},{translateX:-(values.targetWidth/2-values.targetHeight/2)},{translateY:values.targetWidth/2-values.targetHeight/2}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Rotate.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","opacity","transform","rotate","translateX","translateY","targetWidth","targetHeight"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Rotate.ts"],"mappings":"AA4JY,SAAAA,SAAMA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEjB,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAC,CACnDM,SAAS,CAAE,CACT,CAAEC,MAAM,CAAEV,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,MAAM,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC3D,CAAEQ,UAAU,CAAEX,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC1D,CAAES,UAAU,CAAEZ,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAE,CAAC,CAE9D,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACVC,SAAS,CAAE,CACT,CAAEC,MAAM,CAAE,QAAS,CAAC,CACpB,CAAEC,UAAU,CAAE,EAAEZ,MAAM,CAACc,WAAW,CAAG,CAAC,CAAGd,MAAM,CAACe,YAAY,CAAG,CAAC,CAAE,CAAC,CACnE,CAAEF,UAAU,CAAEb,MAAM,CAACc,WAAW,CAAG,CAAC,CAAGd,MAAM,CAACe,YAAY,CAAG,CAAE,CAAC,CACjE,CACD,GAAGV,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var RotateInUpRight = exports.RotateInUpRight = function(_ComplexAnimationBuil4) {
    (0, _inherits2.default)(RotateInUpRight, _ComplexAnimationBuil4);
    var _super4 = _createSuper(RotateInUpRight);
    function RotateInUpRight() {
        var _this4;
        (0, _classCallCheck2.default)(this, RotateInUpRight);
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++){
            args[_key4] = arguments[_key4];
        }
        _this4 = _super4.call.apply(_super4, [
            this
        ].concat(args));
        _this4.build = function() {
            var delayFunction = _this4.getDelayFunction();
            var _this4$getAnimationAn = _this4.getAnimationAndConfig(), _this4$getAnimationAn2 = (0, _slicedToArray2.default)(_this4$getAnimationAn, 2), animation = _this4$getAnimationAn2[0], config = _this4$getAnimationAn2[1];
            var delay = _this4.getDelay();
            var callback = _this4.callbackV;
            var initialValues = _this4.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            opacity: delayFunction(delay, animation(1, config)),
                            transform: [
                                {
                                    rotate: delayFunction(delay, animation("0deg", config))
                                },
                                {
                                    translateX: delayFunction(delay, animation(0, config))
                                },
                                {
                                    translateY: delayFunction(delay, animation(0, config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            opacity: 0,
                            transform: [
                                {
                                    rotate: "-90deg"
                                },
                                {
                                    translateX: -(values.targetWidth / 2 - values.targetHeight / 2)
                                },
                                {
                                    translateY: values.targetWidth / 2 - values.targetHeight / 2
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_2345342195739_init_data;
                anonymous.__workletHash = 2345342195739;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this4;
    }
    (0, _createClass2.default)(RotateInUpRight, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new RotateInUpRight();
            }
        }
    ]);
    return RotateInUpRight;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_1086283856442_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,animation(0,config)),transform:[{rotate:delayFunction(delay,animation('90deg',config))},{translateX:delayFunction(delay,animation(values.currentWidth/2-values.currentHeight/2,config))},{translateY:delayFunction(delay,animation(values.currentWidth/2-values.currentHeight/2,config))}]},initialValues:{opacity:1,transform:[{rotate:'0deg'},{translateX:0},{translateY:0}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Rotate.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","opacity","transform","rotate","translateX","currentWidth","currentHeight","translateY"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Rotate.ts"],"mappings":"AAuMY,SAAAA,SAAMA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEjB,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAC,CACnDM,SAAS,CAAE,CACT,CAAEC,MAAM,CAAEV,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,OAAO,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC5D,CACEQ,UAAU,CAAEX,aAAa,CACvBC,KAAK,CACLC,SAAS,CACPH,MAAM,CAACa,YAAY,CAAG,CAAC,CAAGb,MAAM,CAACc,aAAa,CAAG,CAAC,CAClDV,MACF,CACF,CACF,CAAC,CACD,CACEW,UAAU,CAAEd,aAAa,CACvBC,KAAK,CACLC,SAAS,CACPH,MAAM,CAACa,YAAY,CAAG,CAAC,CAAGb,MAAM,CAACc,aAAa,CAAG,CAAC,CAClDV,MACF,CACF,CACF,CAAC,CAEL,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACVC,SAAS,CAAE,CAAC,CAAEC,MAAM,CAAE,MAAO,CAAC,CAAE,CAAEC,UAAU,CAAE,CAAE,CAAC,CAAE,CAAEG,UAAU,CAAE,CAAE,CAAC,CAAC,CACrE,GAAGV,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var RotateOutDownLeft = exports.RotateOutDownLeft = function(_ComplexAnimationBuil5) {
    (0, _inherits2.default)(RotateOutDownLeft, _ComplexAnimationBuil5);
    var _super5 = _createSuper(RotateOutDownLeft);
    function RotateOutDownLeft() {
        var _this5;
        (0, _classCallCheck2.default)(this, RotateOutDownLeft);
        for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++){
            args[_key5] = arguments[_key5];
        }
        _this5 = _super5.call.apply(_super5, [
            this
        ].concat(args));
        _this5.build = function() {
            var delayFunction = _this5.getDelayFunction();
            var _this5$getAnimationAn = _this5.getAnimationAndConfig(), _this5$getAnimationAn2 = (0, _slicedToArray2.default)(_this5$getAnimationAn, 2), animation = _this5$getAnimationAn2[0], config = _this5$getAnimationAn2[1];
            var delay = _this5.getDelay();
            var callback = _this5.callbackV;
            var initialValues = _this5.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            opacity: delayFunction(delay, animation(0, config)),
                            transform: [
                                {
                                    rotate: delayFunction(delay, animation("90deg", config))
                                },
                                {
                                    translateX: delayFunction(delay, animation(values.currentWidth / 2 - values.currentHeight / 2, config))
                                },
                                {
                                    translateY: delayFunction(delay, animation(values.currentWidth / 2 - values.currentHeight / 2, config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            opacity: 1,
                            transform: [
                                {
                                    rotate: "0deg"
                                },
                                {
                                    translateX: 0
                                },
                                {
                                    translateY: 0
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_1086283856442_init_data;
                anonymous.__workletHash = 1086283856442;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this5;
    }
    (0, _createClass2.default)(RotateOutDownLeft, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new RotateOutDownLeft();
            }
        }
    ]);
    return RotateOutDownLeft;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_764784632347_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,animation(0,config)),transform:[{rotate:delayFunction(delay,animation('-90deg',config))},{translateX:delayFunction(delay,animation(-(values.currentWidth/2-values.currentHeight/2),config))},{translateY:delayFunction(delay,animation(values.currentWidth/2-values.currentHeight/2,config))}]},initialValues:{opacity:1,transform:[{rotate:'0deg'},{translateX:0},{translateY:0}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Rotate.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","opacity","transform","rotate","translateX","currentWidth","currentHeight","translateY"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Rotate.ts"],"mappings":"AA8PY,SAAAA,SAAMA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEjB,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAC,CACnDM,SAAS,CAAE,CACT,CAAEC,MAAM,CAAEV,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,QAAQ,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC7D,CACEQ,UAAU,CAAEX,aAAa,CACvBC,KAAK,CACLC,SAAS,CACP,EAAEH,MAAM,CAACa,YAAY,CAAG,CAAC,CAAGb,MAAM,CAACc,aAAa,CAAG,CAAC,CAAC,CACrDV,MACF,CACF,CACF,CAAC,CACD,CACEW,UAAU,CAAEd,aAAa,CACvBC,KAAK,CACLC,SAAS,CACPH,MAAM,CAACa,YAAY,CAAG,CAAC,CAAGb,MAAM,CAACc,aAAa,CAAG,CAAC,CAClDV,MACF,CACF,CACF,CAAC,CAEL,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACVC,SAAS,CAAE,CAAC,CAAEC,MAAM,CAAE,MAAO,CAAC,CAAE,CAAEC,UAAU,CAAE,CAAE,CAAC,CAAE,CAAEG,UAAU,CAAE,CAAE,CAAC,CAAC,CACrE,GAAGV,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var RotateOutDownRight = exports.RotateOutDownRight = function(_ComplexAnimationBuil6) {
    (0, _inherits2.default)(RotateOutDownRight, _ComplexAnimationBuil6);
    var _super6 = _createSuper(RotateOutDownRight);
    function RotateOutDownRight() {
        var _this6;
        (0, _classCallCheck2.default)(this, RotateOutDownRight);
        for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++){
            args[_key6] = arguments[_key6];
        }
        _this6 = _super6.call.apply(_super6, [
            this
        ].concat(args));
        _this6.build = function() {
            var delayFunction = _this6.getDelayFunction();
            var _this6$getAnimationAn = _this6.getAnimationAndConfig(), _this6$getAnimationAn2 = (0, _slicedToArray2.default)(_this6$getAnimationAn, 2), animation = _this6$getAnimationAn2[0], config = _this6$getAnimationAn2[1];
            var delay = _this6.getDelay();
            var callback = _this6.callbackV;
            var initialValues = _this6.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            opacity: delayFunction(delay, animation(0, config)),
                            transform: [
                                {
                                    rotate: delayFunction(delay, animation("-90deg", config))
                                },
                                {
                                    translateX: delayFunction(delay, animation(-(values.currentWidth / 2 - values.currentHeight / 2), config))
                                },
                                {
                                    translateY: delayFunction(delay, animation(values.currentWidth / 2 - values.currentHeight / 2, config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            opacity: 1,
                            transform: [
                                {
                                    rotate: "0deg"
                                },
                                {
                                    translateX: 0
                                },
                                {
                                    translateY: 0
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_764784632347_init_data;
                anonymous.__workletHash = 764784632347;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this6;
    }
    (0, _createClass2.default)(RotateOutDownRight, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new RotateOutDownRight();
            }
        }
    ]);
    return RotateOutDownRight;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_4716893210107_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,animation(0,config)),transform:[{rotate:delayFunction(delay,animation('-90deg',config))},{translateX:delayFunction(delay,animation(values.currentWidth/2-values.currentHeight/2,config))},{translateY:delayFunction(delay,animation(-(values.currentWidth/2-values.currentHeight/2),config))}]},initialValues:{opacity:1,transform:[{rotate:'0deg'},{translateX:0},{translateY:0}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Rotate.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","opacity","transform","rotate","translateX","currentWidth","currentHeight","translateY"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Rotate.ts"],"mappings":"AAqTY,SAAAA,SAAMA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEjB,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAC,CACnDM,SAAS,CAAE,CACT,CAAEC,MAAM,CAAEV,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,QAAQ,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC7D,CACEQ,UAAU,CAAEX,aAAa,CACvBC,KAAK,CACLC,SAAS,CACPH,MAAM,CAACa,YAAY,CAAG,CAAC,CAAGb,MAAM,CAACc,aAAa,CAAG,CAAC,CAClDV,MACF,CACF,CACF,CAAC,CACD,CACEW,UAAU,CAAEd,aAAa,CACvBC,KAAK,CACLC,SAAS,CACP,EAAEH,MAAM,CAACa,YAAY,CAAG,CAAC,CAAGb,MAAM,CAACc,aAAa,CAAG,CAAC,CAAC,CACrDV,MACF,CACF,CACF,CAAC,CAEL,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACVC,SAAS,CAAE,CAAC,CAAEC,MAAM,CAAE,MAAO,CAAC,CAAE,CAAEC,UAAU,CAAE,CAAE,CAAC,CAAE,CAAEG,UAAU,CAAE,CAAE,CAAC,CAAC,CACrE,GAAGV,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var RotateOutUpLeft = exports.RotateOutUpLeft = function(_ComplexAnimationBuil7) {
    (0, _inherits2.default)(RotateOutUpLeft, _ComplexAnimationBuil7);
    var _super7 = _createSuper(RotateOutUpLeft);
    function RotateOutUpLeft() {
        var _this7;
        (0, _classCallCheck2.default)(this, RotateOutUpLeft);
        for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++){
            args[_key7] = arguments[_key7];
        }
        _this7 = _super7.call.apply(_super7, [
            this
        ].concat(args));
        _this7.build = function() {
            var delayFunction = _this7.getDelayFunction();
            var _this7$getAnimationAn = _this7.getAnimationAndConfig(), _this7$getAnimationAn2 = (0, _slicedToArray2.default)(_this7$getAnimationAn, 2), animation = _this7$getAnimationAn2[0], config = _this7$getAnimationAn2[1];
            var delay = _this7.getDelay();
            var callback = _this7.callbackV;
            var initialValues = _this7.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            opacity: delayFunction(delay, animation(0, config)),
                            transform: [
                                {
                                    rotate: delayFunction(delay, animation("-90deg", config))
                                },
                                {
                                    translateX: delayFunction(delay, animation(values.currentWidth / 2 - values.currentHeight / 2, config))
                                },
                                {
                                    translateY: delayFunction(delay, animation(-(values.currentWidth / 2 - values.currentHeight / 2), config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            opacity: 1,
                            transform: [
                                {
                                    rotate: "0deg"
                                },
                                {
                                    translateX: 0
                                },
                                {
                                    translateY: 0
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_4716893210107_init_data;
                anonymous.__workletHash = 4716893210107;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this7;
    }
    (0, _createClass2.default)(RotateOutUpLeft, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new RotateOutUpLeft();
            }
        }
    ]);
    return RotateOutUpLeft;
}(_animationBuilder.ComplexAnimationBuilder);
var _worklet_13019380819610_init_data = {
    code: "function anonymous(values){const{delayFunction,delay,animation,config,initialValues,callback}=this.__closure;return{animations:{opacity:delayFunction(delay,animation(0,config)),transform:[{rotate:delayFunction(delay,animation('90deg',config))},{translateX:delayFunction(delay,animation(-(values.currentWidth/2-values.currentHeight/2),config))},{translateY:delayFunction(delay,animation(-(values.currentWidth/2-values.currentHeight/2),config))}]},initialValues:{opacity:1,transform:[{rotate:'0deg'},{translateX:0},{translateY:0}],...initialValues},callback:callback};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Rotate.ts",
    sourceMap: '{"version":3,"names":["anonymous","values","delayFunction","delay","animation","config","initialValues","callback","__closure","animations","opacity","transform","rotate","translateX","currentWidth","currentHeight","translateY"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/layoutReanimation/defaultAnimations/Rotate.ts"],"mappings":"AA4WY,SAAAA,SAAMA,CAAKC,MAAA,QAAAC,aAAA,CAAAC,KAAA,CAAAC,SAAA,CAAAC,MAAA,CAAAC,aAAA,CAAAC,QAAA,OAAAC,SAAA,CAEjB,MAAO,CACLC,UAAU,CAAE,CACVC,OAAO,CAAER,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,CAAC,CAAEC,MAAM,CAAC,CAAC,CACnDM,SAAS,CAAE,CACT,CAAEC,MAAM,CAAEV,aAAa,CAACC,KAAK,CAAEC,SAAS,CAAC,OAAO,CAAEC,MAAM,CAAC,CAAE,CAAC,CAC5D,CACEQ,UAAU,CAAEX,aAAa,CACvBC,KAAK,CACLC,SAAS,CACP,EAAEH,MAAM,CAACa,YAAY,CAAG,CAAC,CAAGb,MAAM,CAACc,aAAa,CAAG,CAAC,CAAC,CACrDV,MACF,CACF,CACF,CAAC,CACD,CACEW,UAAU,CAAEd,aAAa,CACvBC,KAAK,CACLC,SAAS,CACP,EAAEH,MAAM,CAACa,YAAY,CAAG,CAAC,CAAGb,MAAM,CAACc,aAAa,CAAG,CAAC,CAAC,CACrDV,MACF,CACF,CACF,CAAC,CAEL,CAAC,CACDC,aAAa,CAAE,CACbI,OAAO,CAAE,CAAC,CACVC,SAAS,CAAE,CAAC,CAAEC,MAAM,CAAE,MAAO,CAAC,CAAE,CAAEC,UAAU,CAAE,CAAE,CAAC,CAAE,CAAEG,UAAU,CAAE,CAAE,CAAC,CAAC,CACrE,GAAGV,aACL,CAAC,CACDC,QAAQ,CAAEA,QACZ,CAAC,CACH"}',
    version: "3.5.4"
};
var RotateOutUpRight = exports.RotateOutUpRight = function(_ComplexAnimationBuil8) {
    (0, _inherits2.default)(RotateOutUpRight, _ComplexAnimationBuil8);
    var _super8 = _createSuper(RotateOutUpRight);
    function RotateOutUpRight() {
        var _this8;
        (0, _classCallCheck2.default)(this, RotateOutUpRight);
        for(var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++){
            args[_key8] = arguments[_key8];
        }
        _this8 = _super8.call.apply(_super8, [
            this
        ].concat(args));
        _this8.build = function() {
            var delayFunction = _this8.getDelayFunction();
            var _this8$getAnimationAn = _this8.getAnimationAndConfig(), _this8$getAnimationAn2 = (0, _slicedToArray2.default)(_this8$getAnimationAn, 2), animation = _this8$getAnimationAn2[0], config = _this8$getAnimationAn2[1];
            var delay = _this8.getDelay();
            var callback = _this8.callbackV;
            var initialValues = _this8.initialValues;
            return function() {
                var _e = [
                    new global.Error(),
                    -7,
                    -27
                ];
                var anonymous = function anonymous(values) {
                    return {
                        animations: {
                            opacity: delayFunction(delay, animation(0, config)),
                            transform: [
                                {
                                    rotate: delayFunction(delay, animation("90deg", config))
                                },
                                {
                                    translateX: delayFunction(delay, animation(-(values.currentWidth / 2 - values.currentHeight / 2), config))
                                },
                                {
                                    translateY: delayFunction(delay, animation(-(values.currentWidth / 2 - values.currentHeight / 2), config))
                                }
                            ]
                        },
                        initialValues: Object.assign({
                            opacity: 1,
                            transform: [
                                {
                                    rotate: "0deg"
                                },
                                {
                                    translateX: 0
                                },
                                {
                                    translateY: 0
                                }
                            ]
                        }, initialValues),
                        callback: callback
                    };
                };
                anonymous.__closure = {
                    delayFunction: delayFunction,
                    delay: delay,
                    animation: animation,
                    config: config,
                    initialValues: initialValues,
                    callback: callback
                };
                anonymous.__initData = _worklet_13019380819610_init_data;
                anonymous.__workletHash = 13019380819610;
                anonymous.__stackDetails = _e;
                return anonymous;
            }();
        };
        return _this8;
    }
    (0, _createClass2.default)(RotateOutUpRight, null, [
        {
            key: "createInstance",
            value: function createInstance() {
                return new RotateOutUpRight();
            }
        }
    ]);
    return RotateOutUpRight;
}(_animationBuilder.ComplexAnimationBuilder);
